export const environment = {
  production: true,
  backendUrl: 'https://apiv2.back2action.de/',
};



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/environments/environment.ts